import { create } from 'zustand';
import type { ReactionKind } from '@durak/shared';
import { getSocket } from '../lib/socket';

export interface ReactionEvent {
  id: number;
  fromId: string;
  name: string;
  kind: ReactionKind;
  ts: number;
}

let nextId = 1;
const DISPLAY_MS = 2400;

interface State {
  reactions: ReactionEvent[];
  attach: () => () => void;
}

export const useReactions = create<State>((set, get) => ({
  reactions: [],
  attach: () => {
    const s = getSocket();
    const onReaction = (e: { from: string; name: string; kind: ReactionKind; ts: number }) => {
      const id = nextId++;
      const event: ReactionEvent = { id, fromId: e.from, name: e.name, kind: e.kind, ts: e.ts };
      set({ reactions: [...get().reactions, event] });
      setTimeout(() => {
        set({ reactions: get().reactions.filter(r => r.id !== id) });
      }, DISPLAY_MS);
    };
    s.on('game:reaction', onReaction);
    return () => s.off('game:reaction', onReaction);
  },
}));
